module.exports = __webpack_public_path__ + "img-dashboard/register/web-cv-wirobrajan.68482114.png";